import React, { PureComponent } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import styles from "./VisualitzacioMapa.module.css";
import {
  MAX_NATIVE_ZOOM_CATALUNYA,
  MIN_NATIVE_ZOOM_CATALUNYA
} from "../../constantsFormularis";

const centreCatalunya = {
  latitud: 41.68669,
  longitud: 0.71224
};

const defaultZoom = 8;

class VisualitzacioMapa extends PureComponent {
  state = {
    lMap: null,
    lControl: null
  };

  componentDidMount() {
    if (this.container) {
      //TODO: extreure a una funcio de configuracio del mapa
      // MAD: afegeixo min i maxZoom
      let map = L.map(this.container, {
        minZoom: MIN_NATIVE_ZOOM_CATALUNYA,
        maxZoom: MAX_NATIVE_ZOOM_CATALUNYA,
        zoomControl: false
      }).setView(
        [centreCatalunya.latitud, centreCatalunya.longitud],
        defaultZoom
      );
      let control = L.control.layers().addTo(map);

      this.setState(state => ({
        ...state,
        lMap: map,
        lControl: control
      }));
    }
  }

  render() {
    return (
      <div
        className={styles.MapaLeaflet}
        ref={ref => {
          this.container = ref;
        }}
      >
        {this.props.children(this.state.lMap, this.state.lControl)}
      </div>
    );
  }
}

export default VisualitzacioMapa;
